import React, { useContext } from 'react';
import './FisherProfile.scss';

import bannerBackground from './AssetsFisher/bannerPhoto.png';
import profilePhoto from './AssetsFisher/fisherPhoto.png';
import marketerPhoto from './AssetsFisher/marketerPhoot.svg';
import organizationPhoto from './AssetsFisher/organizationPhoto.svg';

import CountryLocationIcon from './AssetsFisher/FisherProfileIcons/CountryLocationIcon.svg';
import DeliveryCarIcon from './AssetsFisher/FisherProfileIcons/DeliveryCarIcon.svg';
import LocationIcon from './AssetsFisher/FisherProfileIcons/LocationIcon.svg';
import MailIcon from './AssetsFisher/FisherProfileIcons/MailIcon.svg';
import ProfileIcon from './AssetsFisher/FisherProfileIcons/ProfileIcon.svg';
import WebIcon from './AssetsFisher/FisherProfileIcons/WebIcon.svg';
import WhatsappIcon from './AssetsFisher/FisherProfileIcons/WhatsappIcon.svg';
import RetiroCaja from './AssetsFisher/retiroCaja.svg';

import UploadProduct from './AssetsFisher/uploadProduct.svg';
import { useState } from 'react';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { uiContext } from '../common';
import { API } from '../../services/api';

const RenderCommnets = (numberOfComments) => {
    let Comments = [];
    for (let i = 0; i < numberOfComments; i++) {
        Comments.push(<div className="comment">
            <div className="photoSection">
                <img src={UploadProduct} alt="" />
            </div>
            <div className="contentSection">
                <span className="commentTitle">Raul Linderos</span>
                <span className="commentContent">Lorem ipsum, dolor sit amet consectetur adipisicing elit. Blanditiis placeat nihil est, minus sequi delectus expedita quia repudiandae, dolorum quidem ullam! Distinctio sequi sed ipsam. Explicabo placeat iste ullam tempore! Lorem ipsum dolor, sit amet consectetur adipisicing elit. Soluta, minima adipisci blanditiis consectetur earum veniam voluptatibus sit non, fuga itaque doloribus iure laboriosam illo perspiciatis necessitatibus tenetur, recusandae est accusantium.</span>
            </div>
        </div>);
    }
    return Comments;
}


const getClassNamePerType = (profileType) => {
    switch (profileType) {
        case "fisher": return "fisherContent orangeBackground";
        case "organization": return "fisherContent blueBackground";
        case "commercial": return "fisherContent cyanBackground";
        default: return "fisherContent";
    }
}

const FisherProfile = () => {
    /**
     * Vista del perfil de pescador
     * Esta vista el visitante puede ver los productos que ofrece el pescador y sus datos
     */
    const [profileType, SetProfileType] = useState("fisher");


    let { _id } = useParams();

    const [phone, setPhone] = useState("");
    const [whatsapp, setWhatsapp] = useState("");
    const [email, setEmail] = useState("");
    const [website, setWebsite] = useState("");
    const [region, setRegion] = useState("");

    const [city, setCity] = useState("");
    const [commune, setCommune] = useState("");
    const [sector, setSector] = useState("");

    const [name, setName] = useState("");
    const [message, setMessage] = useState("");

    const [products, setProducts] = useState([]);

    const [photoUrl, setPhotoUrl] = useState(null);
    const [coverUrl, setCoverUrl] = useState(null);
    const [type, setType] = useState("FISHER");

    const [personalDeliveryEnabled, setPersonalDeliveryEnabled] = useState(false);
    const [deliveryEnabled, setDeliveryEnabled] = useState(false);

    const uicontext = useContext(uiContext);

    useEffect(() => {
        uicontext.showLoader(true);
        /**
         * Obtener el usuario por el _id
         * Se hace le llamado al servicio 
         */
        API.putUserById(_id)
            .then(response => {
                if(response._id){
                    console.log(response);
                    setPhone(response.name);
                    setWhatsapp(response.mobilePhone);
                    setEmail(response.email);
                    setWebsite(response.website);
                    setRegion(response.regionKey);
                    setCity(response.cityKey);
                    setCommune(response.communeKey);
                    setSector(response.sectorKey);

                    setName(response.name);
                    setMessage(response.message);

                    setProducts(response.products);

                    setType(response.type);
                    setPhotoUrl(response.photoUrl);
                    setCoverUrl(response.coverUrl);

                    setPersonalDeliveryEnabled(response.personalDeliveryEnabled !== null ? response.personalDeliveryEnabled : false);
                    setDeliveryEnabled(response.deliveryEnabled !== null ? response.deliveryEnabled : false);
                    uicontext.hideLoader();
                }
            })
            .catch(x => {
                uicontext.hideLoader();
            })
    }, []);

    const renderProducts = () => {
        let productsToRender = [];
        for (let i = 0; i < products.length; i++) {
            productsToRender.push(
                <div key={i} className="productContainer">
                    <img src={products[i].photoUrl} alt="" />
                    <span>{products[i].name}</span>
                </div>
            )

        }
        return productsToRender;
    }

    const getUserTypeDefaultPhoto = () => {
        switch (type) {
            case "FISHER": return profilePhoto;
            case "MARKETER": return marketerPhoto;
            case "ORGANIZATION": return organizationPhoto;
            default:
                return profilePhoto;
        }
    }

    const getUserTypeDefaultBanner = () => {
        switch (type) {
            case "FISHER": return bannerBackground;
            case "MARKETER": return bannerBackground;
            case "ORGANIZATION": return bannerBackground;
            default:
                return bannerBackground;
        }
    }

    return (
        <div className="FisherProfileMasterContainer">
            <div className="subContainer">
                <div className="profileBanner">
                    <img src={(!coverUrl) ? getUserTypeDefaultBanner() : coverUrl} alt="" />
                </div>

                <div className="profilePhoto">
                    <div className="photoContainer">
                        <img src={!photoUrl ? getUserTypeDefaultPhoto() : photoUrl} alt="" />
                    </div>
                </div>

                <div className={getClassNamePerType(profileType)}>
                    {type === "FISHER" && <span className="fisherName">Pescador: {name}</span>}
                    {type === "ORGANIZATION" && <span className="fisherName">Organizacion: {name}</span>}
                    {type === "MARKETER" && <span className="fisherName">Comercializadora: {name}</span>}
                    <div className="fieldsContainer">
                        <div className="fieldContainer">
                            <img src={ProfileIcon} alt="" />
                            <span>Nombre: {phone}</span>
                        </div>
                        <div className="fieldContainer">
                            <img src={CountryLocationIcon} alt="" />
                            <span>Provincia: {city}</span>
                        </div>

                        <div className="fieldContainer">
                            <img src={WhatsappIcon} alt="" />
                            <span>Whatsapp: {whatsapp}</span>
                        </div>
                        <div className="fieldContainer">
                            <img src={LocationIcon} alt="" />
                            <span>Comuna: {commune}</span>
                        </div>

                        <div className="fieldContainer">
                            <img src={MailIcon} alt="" />
                            <span>Email: {email}</span>
                        </div>
                        <div className="fieldContainer">
                            <img src={LocationIcon} alt="" />
                            <span>Caleta: {sector}</span>
                        </div>

                        <div className="fieldContainer">
                            <img src={WebIcon} alt="" />
                            <span>Website: {website}</span>
                        </div>
                        <div className="fieldContainer">
                            <img src={RetiroCaja} alt="" />
                            <span>Retiro en caleta: {personalDeliveryEnabled === false ? "No" : "Si"}</span>
                        </div>

                        <div className="fieldContainer">
                            <img src={CountryLocationIcon} alt="" />
                            <span>Región: {region}</span>
                        </div>
                        <div className="fieldContainer">
                            <img src={DeliveryCarIcon} alt="" />
                            <span>Despacho a domicilio: {deliveryEnabled === false ? "No" : "Si"}</span>
                        </div>
                    </div>

                </div>

                <div className="fisherMessage">
                    {type === "FISHER" && <span className="fisherMessageSubtitle">Mensaje del pescador</span>}
                    {type === "ORGANIZATION" && <span className="fisherMessageSubtitle">Mensaje de la organizacion</span>}
                    {type === "MARKETER" && <span className="fisherMessageSubtitle">Mensaje de la comercializadora</span>}
                    <span className="fisherMessageContent">
                        {message}
                    </span>
                </div>

                <div className="fisherProducts">
                    <span className="fisherProductsSubtitle">Productos que ofrece</span>
                    <div className="ProductsSubcontainer">
                        {renderProducts()}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FisherProfile;